import { useWorkFlow } from "../../../contexts/workflow";
var useMap = function useMap() {
  var _currentQuestion$publ, _currentQuestion$publ2, _currentQuestion$publ3, _collector$resources;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var currentQuestion = collector.currentQuestion;
  var zoom = currentQuestion === null || currentQuestion === void 0 || (_currentQuestion$publ = currentQuestion.publicParameters) === null || _currentQuestion$publ === void 0 ? void 0 : _currentQuestion$publ.zoom;
  var center = currentQuestion === null || currentQuestion === void 0 || (_currentQuestion$publ2 = currentQuestion.publicParameters) === null || _currentQuestion$publ2 === void 0 ? void 0 : _currentQuestion$publ2.center;
  var numberBaseMap = currentQuestion === null || currentQuestion === void 0 || (_currentQuestion$publ3 = currentQuestion.publicParameters) === null || _currentQuestion$publ3 === void 0 ? void 0 : _currentQuestion$publ3.basemap;
  center = !center ? null : JSON.parse(center);
  var community = collector.diag ? collector.diag.community : {
    polygon: null,
    polygonColor: null,
    basemap: null
  };
  var basemap = collector === null || collector === void 0 || (_collector$resources = collector.resources) === null || _collector$resources === void 0 || (_collector$resources = _collector$resources.map) === null || _collector$resources === void 0 ? void 0 : _collector$resources.tiles;
  var listBaseMap = basemap || ['https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png'];
  return {
    zoom: zoom,
    mapZoom: zoom,
    center: center,
    baseMap: listBaseMap[numberBaseMap || community.basemap || 0]
  };
};
export default useMap;